import { BasePodcastEditRouteStore } from "administration/podcast/stores";
import { TorahAnytimeService } from "common/services";

class PodcastEditRouteStore extends BasePodcastEditRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.torahAnytimeService = this.rootStore.createApplicationService(TorahAnytimeService);
    }

    async createPodcast(resource) {
        const response = await this.service.create(resource);
        return response.data;
    }

    async getPodcast(id) {
        const response = await this.service.get(id, {
            embed: "podcastFeed,genres,language,location,podcastVolumes,producer,podcastCategory,torahAnytimeTopics,torahAnytimeSpeakers",
        });
        return response.data;
    }

    async updatePodcast(resource) {
        const response = await this.service.update(resource);
        return response.data;
    }

    async updatePodcastActiveStatus(id, isActive, cascadeToChildren = false) {
        const response = await this.service.updateActiveStatus(id, isActive, cascadeToChildren);
        return response.data;
    }

    async updatePodcastScheduledReleaseAt(id, scheduledReleaseAt) {
        const response = await this.service.updateScheduledReleaseAt(id, scheduledReleaseAt);
        return response.data;
    }

    async getTorahAnytimeSetting() {
        const response = await this.torahAnytimeService.getSetting();
        return response.data;
    }

    async findTopics(params, abortController) {
        const response = await this.torahAnytimeService.findTopics(params, abortController);
        return response.data;
    }

    async findSpeakers(params, abortController) {
        const response = await this.torahAnytimeService.findSpeakers(params, abortController);
        return response.data;
    }

    async findSpeakersByGender(params, abortController) {
        const response = await this.torahAnytimeService.findSpeakersByGender(params);
        return response.data;
    }
}

export default PodcastEditRouteStore;
